import React from 'react'
import { Button, Image, Modal, Segment, Table } from 'semantic-ui-react'

import close from '../../assets/images/close.png'
import Day from './day'
import { tr } from '../../helpers/languages'

const Editor = (props) => {
    return (
        <Modal className='editor' open onClose={(_e) => { props.onClose() }}>
            <Modal.Header>
                <Image className='close-modal' src={close} onClick={(_e) => { props.onClose() }}/>
            </Modal.Header>
            <Modal.Content>
                <Segment.Group horizontal className='editor-header'>
                    <Segment className='availability'>{tr('AVAILABILITY')}</Segment>
                    <Segment className='day'>{tr('DAY')}</Segment>
                    <Segment className='slots'>{tr('HOUR')}</Segment>
                </Segment.Group>
                <div className='l1'>
                    <Table>
                        <Table.Body>
                            {
                                /* eslint-disable react/no-array-index-key */
                                props.schedule.map((day, index) => {
                                    return (
                                        <Day
                                            key={`day${index}`}
                                            prefix={`day${index}`}
                                            day={day}
                                            last={index === props.schedule.length - 1}
                                            errors={props.errors[index] || {}}
                                            onAddSlot={() => { props.onAddSlot(index) }}
                                            onRemoveSlot={(slot) => { props.onRemoveSlot(index, slot) }}
                                            onChangeSlot={(slot, field, value) => { props.onChangeSlot(index, slot, field, value) }}
                                            onToggleAvailability={() => { props.onToggleAvailability(index) }}
                                        />
                                    )
                                })
                                /* eslint-enable react/no-array-index-key */
                            }
                        </Table.Body>
                    </Table>
                </div>
                <Segment className='editor-buttons right aligned'>
                    <Button
                        className={`clear-all ${props.doNotDisturb ? 'do-not-disturb' : ''}`}
                        onClick={(_e) => { props.onResetAvailability() }}
                    >
                        {tr('CLEAR_ALL')}
                    </Button>
                    <Button
                        className={`save ${props.doNotDisturb ? 'do-not-disturb' : ''}`}
                        onClick={(_e) => { props.onSaveAvailability() }}
                    >
                        {tr('SAVE')}
                    </Button>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default Editor



// WEBPACK FOOTER //
// ./src/components/availability/editor.js